import { ApiBaseService, ApiService } from './api.base.service';
import store from '@/store/store';
import { Site, SuccessResponse } from '../types';
import { SearchResponse } from './task.service';

export type SearchLocationsResponse = { locations: Location[] } & SearchResponse;

export class LocationService {
  private api: ApiBaseService;

  constructor() {
    this.api = ApiService;
  }

  public async getLocation(site: Site, locationId: number): Promise<Location> {
    const organisation = store.getters.activeOrganisation[0].id;
    return this.api.get(`organisation/${organisation}/project/${site.project_id}/site/${site.id}/location/${locationId}`);
  }

  public async getLocations(take: number = 0, skip: number = 0): Promise<SearchLocationsResponse> {
    const organisation = store.getters.activeOrganisation[0].id;
    return this.api.get(`organisation/${organisation}/locations?take=${take}&skip=${skip}`);
  }

  public async getLocationsForSite(site: Site, projectId: number = 0, take: number = 0, skip: number = 0): Promise<SearchLocationsResponse> {
    const organisation = store.getters.activeOrganisation[0].id;
    const projId = projectId || site.project_id;
    return this.api.get(`organisation/${organisation}/project/${projectId}/site/${site.id}/locations?take=${take}&skip=${skip}`);
  }

  public async createLocation(location: any): Promise<Location> {
    const organisation = store.getters.activeOrganisation[0].id;
    return this.api.post(`organisation/${organisation}/project/${location.project_id}/site/${location.site_id}/location`,
      { name: location.name });
  }

  public async updateLocation(projectId: number, siteId: number, locationId: number, payload: object): Promise<Location> {
    const organisation = store.getters.activeOrganisation[0].id;
    return this.api.put(
      `organisation/${organisation}/project/${projectId}/site/${siteId}/location/${locationId}`, payload,
    );
  }

  public async deleteLocation(projectId: number, siteId: number, locationId: number): Promise<SuccessResponse> {
    const organisation = store.getters.activeOrganisation[0].id;
    return this.api.delete(
      `organisation/${organisation}/project/${projectId}/site/${siteId}/location/${locationId}`,
    );
  }
}

export default new LocationService();
